import React from 'react';
import BasicModal from './BasicModal';
import icon_discard from 'images/new_pop_ups/discard.svg';

const CancelModal = (props) => {
    let modalTypes = {
        cancelAnalysis: {
            title: 'Discard Analysis',
            description:
                'There is unsaved work in analysis. Do you really want to discard it?',
            description2:
                '(Analyses are only created once you have clicked “Apply”).'
        }
    };
    return (
        <>
            <BasicModal
                title={modalTypes[props.modalType].title}
                visible={props.visible}
                onCancel={props.onCancel}
                icon={icon_discard}
                onAcceptTitle="Discard"
                onAcceptClassName="red-button"
                onCancelTitle="Continue Editing"
                onAccept={props.onAccept}
            >
                <div>
                    <div>
                        <p
                            className="p-desctiption"
                            style={{ marginBottom: '20px', color: '#3D3F4D' }}
                            dangerouslySetInnerHTML={{
                                __html: modalTypes[props.modalType].description
                            }}
                        ></p>
                        <p
                            className="p-desctiption"
                            style={{
                                height: 93,
                                marginBottom: '0px',
                                color: '#3D3F4D'
                            }}
                            dangerouslySetInnerHTML={{
                                __html: modalTypes[props.modalType].description2
                            }}
                        ></p>
                    </div>
                </div>
            </BasicModal>
        </>
    );
};

export default CancelModal;
